import { isNativePlatform } from 'components/helper/Platform';
import { getSchemeBaseURL, Schemes } from 'defs/customAppSchemes';

/*
 * Reload the whole application, in the web via location reload
 * and inside the native wrapper with a custom URL scheme
 */
export const reload = (): void => {
	if (isNativePlatform()) {
		window.location.href = `${getSchemeBaseURL()}:/${Schemes.LOAD}?url=${document.location.href}`;
	} else {
		window.location.reload();
	}
};
